<app-collection-grid>
    <app-member-plan-assignment
        *ngFor="let item of member.plans; index as i; trackBy: planTrackBy" [userLearningPlan]="item"
        [teamMember]="member"
        (planRemoved)="refetchMember()"
        (dueDateChanged)="refetchMember()">
</app-member-plan-assignment>
</app-collection-grid>
